import { datadogRum } from '@datadog/browser-rum';
import { useContext, useEffect } from 'react';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import useShouldRenderCondensedHero from '~/hooks/vdp/useShouldRenderCondensedHero';

export default function useSetAvailabilityDataDogContext() {
  const { hasEverLoaded } = useContext(UserVehicleContext).vehicleAvailability;
  const shouldRenderCondensedHero = useShouldRenderCondensedHero();

  useEffect(() => {
    if (hasEverLoaded) {
      datadogRum.setGlobalContextProperty(
        'isCondensedHero',
        shouldRenderCondensedHero
      );
    }
  }, [hasEverLoaded, shouldRenderCondensedHero]);
}
